import styled from "styled-components";

import { Wrapper } from "../../components";

export const StyledMain = styled.main`
  padding: 1.5rem 0;
`;
export const StyledMainWrapper = styled(Wrapper)`
  outline: 1px solid #00000020;
  box-shadow: 0 0 1.5rem #00000020;
`;
